module.exports = __webpack_public_path__ + "static/media/eng.8a2421cc.png";